import React from 'react'
import Countries from './Countries'
export default function app() {
 return (
    <Countries />
 )
  
}
